import { render, staticRenderFns } from "./StudySurveyPage.vue?vue&type=template&id=c99073e2&"
import script from "./StudySurveyPage.vue?vue&type=script&lang=ts&"
export * from "./StudySurveyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports